module.exports = __webpack_public_path__ + "img/cloud.9b2e991.svg";